import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpRequest } from '@angular/common/http';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { map, catchError, tap } from 'rxjs/operators';
// import { Loginsgs } from '../model/loginsgs';
import { Login } from '../model/login';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
};
@Injectable({
  providedIn: 'root'
})
export class ApiLoginService {
  // public urlApi = 'http://localhost/valsys/frontend/web/index.php/';
  // public urlApi = 'http://10.9.26.169/sgsapi/frontend/web/index.php/';
  //public urlApi = 'http://sgs-api-dev.mncplaymedia.com/frontend/web/index.php/';
   //public urlApi = 'https://sgs-api-dev.mncplay.id/frontend/web/index.php/';
  // public urlApi = 'http://localhost/apiopencontent/frontend/web/index.php/';
  // public urlApi = 'http://localhost/opencontent/frontend/web/index.php/';
  // public urlApi = 'http://coremanagement-dev.mncplaymedia.com/core-backend/public/';
  // public urlApi = 'http://localhost/sgsapi/frontend/web/index.php/';//local
   //public urlApi = 'http://localhost/sgsapiwrv2/frontend/web/index.php/';//local
  //public urlApi = 'https://sgs-api-dev.mncplay.id/frontend/web/index.php/';//dev public
  public urlApi = 'https://sgs-api.mncplay.id/frontend/web/index.php/';//prod public

  private currentUserSubject: BehaviorSubject<Login>;

  public currentUser: Observable<Login>;

  constructor(private http: HttpClient) { 

    this.currentUserSubject = new BehaviorSubject<Login>(JSON.parse(localStorage.getItem('currentUser')));
    this.currentUser = this.currentUserSubject.asObservable();

  }

  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  public get currentUserValue(): Login {
    return JSON.parse(localStorage.getItem('currentUser'));
  }

  /** POST **/
  loginSgs(params: Login): Observable<Login> {
      // console.log(JSON.stringify(hero));
      // console.log(this.urlApi + 'getUsers')
        return this.http.post<any>(this.urlApi + 'apis/login', JSON.stringify(params), httpOptions)
        // return this.http.get<any>(this.urlApi + 'partner/companies', {})
            .pipe(map(user => {
                // login successful if there's a jwt token in the response
                if (user) {
                    const data = user;
                    console.log(data);
                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    localStorage.setItem('currentUser', JSON.stringify(data));
                    this.currentUserSubject.next(data);
                }

                return user;
            }));
  }

  logout() {

    localStorage.removeItem('currentUser');
    this.currentUserSubject.next(null);
    
  }
}
